import { jsxs as l, jsx as e } from "react/jsx-runtime";
const d = () => /* @__PURE__ */ l(
  "svg",
  {
    width: "100",
    height: "100",
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ l("g", { clipPath: "url(#clip0_7438_62887)", children: [
        /* @__PURE__ */ e(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M100 50C100 77.6145 77.6145 100 50 100C22.3855 100 0 77.6145 0 50C0 22.3855 22.3855 0 50 0C77.6145 0 100 22.3855 100 50Z",
            fill: "#F2DFE1"
          }
        ),
        /* @__PURE__ */ e(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M49.4337 57.7853L71 38.4936C70.1863 36.7341 68.3064 35.5 66.1155 35.5H28.8845C26.6926 35.5 24.8147 36.7331 24 38.4926L45.5823 57.7853C46.6454 58.7382 48.3706 58.7382 49.4337 57.7853Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ e(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M49.6475 57.5178C48.5729 58.4502 46.829 58.4502 45.7545 57.5178L23.939 38.6396C23.6587 39.2263 23.5005 39.8714 23.5005 40.5498V67.1615C23.5005 69.8338 25.9066 72 28.8762 72H66.5096C69.4782 72 71.8853 69.8338 71.8853 67.1615V40.5498C71.8853 39.8714 71.7271 39.2273 71.4469 38.6407L49.6475 57.5178Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ e(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M66.5559 71.5H28.4441C25.4378 71.5 23 69.351 23 66.7V40.3C23 37.649 25.4378 35.5 28.4441 35.5H66.5559C69.5623 35.5 72 37.649 72 40.3V66.7C72 69.351 69.5623 71.5 66.5559 71.5Z",
            stroke: "var(--plac-primary-gray)",
            strokeWidth: "2",
            strokeLinecap: "round"
          }
        ),
        /* @__PURE__ */ e(
          "path",
          {
            d: "M71 38.516L49.4996 57.7616C48.3998 58.7461 46.6177 58.7461 45.518 57.7616L24 38.5",
            stroke: "var(--plac-primary-gray)",
            strokeWidth: "2",
            strokeLinecap: "round"
          }
        ),
        /* @__PURE__ */ e(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M57 39C57 31.269 63.268 25 71 25C78.731 25 85 31.269 85 39C85 46.732 78.731 53 71 53C63.268 53 57 46.732 57 39Z",
            fill: "var(--plac-status-error)"
          }
        ),
        /* @__PURE__ */ e(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M72.6686 32.5L72.1777 41.7853H69.8292L69.3383 32.5H72.6686ZM72.2258 46.2189C71.9307 46.5072 71.52 46.6513 70.9938 46.6513C70.4548 46.6513 70.0377 46.5103 69.7426 46.2284C69.4474 45.9464 69.2998 45.5488 69.2998 45.0356C69.2998 44.5034 69.4442 44.1011 69.7329 43.8286C70.0217 43.5562 70.442 43.42 70.9938 43.42C71.5264 43.42 71.9387 43.5594 72.2306 43.8381C72.5226 44.1169 72.6686 44.5161 72.6686 45.0356C72.6686 45.5362 72.521 45.9306 72.2258 46.2189Z",
            fill: "white"
          }
        )
      ] }),
      /* @__PURE__ */ e("defs", { children: /* @__PURE__ */ e("clipPath", { id: "clip0_7438_62887", children: /* @__PURE__ */ e("rect", { width: "100", height: "100", fill: "white" }) }) })
    ]
  }
);
export {
  d as SentEmailIllustration
};
//# sourceMappingURL=index.es481.js.map
